// extracted by mini-css-extract-plugin
module.exports = {"welcomeTop":"_1TQFqlXS","approvedContainer":"_3Vgjx8xo","approvedMessage":"_27ZWBaq1","approvedHeader":"_3PRqY5HI"};
    if(module.hot) {
      // 1754514957347
      var cssReload = require("!../../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  